const getUsersState = state => state.get('users') || state.users;

const getUserById = (state, { userId }) =>
  getUsersState(state).usersById[userId] || null;

const getEstheticianList = state => getUsersState(state).estheticians || null;
const getEstheticianLoaded = state =>
  getUsersState(state).estheticiansLoaded || false;

export const userSelectors = {
  userById: getUserById,
  estheticianList: getEstheticianList,
  estheticiansLoaded: getEstheticianLoaded
};
